import React from "react";

const Cart = () => {
  return (
    <div>
      <h2>Your Shopping Cart</h2>
      <p>Your cart is currently empty.</p>
    </div>
  );
};

export default Cart;
